export default __webpack_public_path__ + "static/media/service3.5d1a0490.png";